
<template>
  <div>
    <form-filtered-multiselect
      :options="countryOptions"
      :value="storedCountries"
      :placeholder="placeholder"
      :limit-height="limitHeight"
      :hide-selected="hideSelected"
      :disabled="disabled"
      track-by="value"
      label="label"
      @valuesSelected="onCountriesSelected" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({

  props: {
    selectedKeys: {
      default: () => {
        return []
      }
    },
    placeholder: {
      default: 'Please select Countries'
    },
    limitHeight: {
      type: Boolean,
      default: false
    },
    hideSelected: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      storedCountries: []
    }
  },
  computed: {
    ...mapGetters('country', ['countryOptions'])
  },
  watch: {
    selectedKeys: function (newVal) {
      this.storedCountries = newVal
    }
  },
  created () {
    this.storedCountries = this.selectedKeys
  },
  methods: {
    onCountriesSelected (countries:Array<String>):void {
      this.$emit('valuesSelected', countries)
    }
  }
})

</script>

<style>

</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
